import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { appDispatch } from '../../store/store';
import { enterWithJWT } from '../../store/thisUser/thisUserSlice';
import { black, red } from '../../utils/style/colors';
import LoadingCircleIndicator from '../../components/LoadingCircleIndicator';
import messages from './messages';
import { notifyError } from '../../components/Notify/Notify';
import Button from '../../components/Button';
import { navigate } from '@reach/router';

interface IProps {
  token: string;
  afterLogin: () => void;
}

interface TokenPayload {
  iss: string;
  iat: number;
  firstName: string;
  lastName: string;
  birthDate: string;
  gender: string;
  nationalId: string;
  roleId: number;
  role: string;
  organizationTitle: string;
  organizationTypeId: number;
  appId: number;
  [key: string]: any;
}

export const decodeJWT = (token: string) => {
  try {
    return jwtDecode<TokenPayload>(token);
  } catch (ignored) {
    return undefined;
  }
};

const JWTLogin: React.FC<IProps> = ({ token, afterLogin }) => {
  const [failed, setFailed] = useState(false);

  const decodedData = decodeJWT(token);

  const fullName =
    decodedData &&
    `${decodedData?.firstName || ''} ${decodedData?.lastName || ''}`;
  useEffect(() => {
    if (token && token !== '') {
      appDispatch(enterWithJWT({ token, serviceId: 1000, decodedData })).then(
        () => {
          afterLogin();
        },
        (e: any) => {
          notifyError(e);
          setFailed(true);
        }
      );
    }
  }, [token]);

  return (
    <div style={{ color: black }}>
      {!failed && <LoadingCircleIndicator />}
      {failed && (
        <div
          style={{
            color: red,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div>{messages.loginFailed}</div>
          <Button
            onClick={() => {
              navigate('https://op.salamat.gov.ir/login');
            }}
          >
            {messages.loginAgain}{' '}
          </Button>
        </div>
      )}
      {(decodedData?.firstName || decodedData?.lastName) && (
        <span>{messages.logginIn(fullName!)}</span>
      )}
    </div>
  );
};

export default JWTLogin;
